import React, { useState } from "react";
import "../../app/App.css";
import { useDispatch, useSelector } from "react-redux";
import { Select, Tag } from "antd";
import {
  ModalContainer,
  SurveyOptions,
  SelectedSurveyOptions,
} from "./surveyDropDown.styles";
import { selectSurvey } from "../../redux/login/login.selectors";
import { setSurvey } from "../../redux/login/login.actions";
const SurveyDropDown = ({ setObj, obj }) => {
  const dispatch = useDispatch();
  const tsurvey = useSelector(selectSurvey);
  const setSurveyList = (index) => {
    dispatch(setSurvey(index));
  };
  const options = [
    { value: "کافه بازار" },
    { value: "گوگل" },
    { value: "تلگرام" },
    { value: "اینستاگرام" },
    { value: "وبسایت‌های اینترنتی" },
    { value: "دوستان و آشنایان" },
    { value: "بیلبوردهای تبلیغاتی" },
    { value: "برچسب های تبلیغاتی بارنت" },
    { value: "نمایندگان" },
    { value: "سایر" },
  ];

  function tagRender(props) {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    console.log(tsurvey)
    return (
      <Tag
        // color={value}
        onChange={(e) => console.log("sam2", e)}
        onMouseDown={onPreventMouseDown}
        // closable={closable}
        // onClose={onClose}
        style={{
          marginRight: 3,
          border: "transparent",
          backgroundColor: "transparent",
        }}
      >
        {label}
      </Tag>
    );
  }

  return (
    <Select
      className="c-pointer"
      mode="multiple"
      tagRender={tagRender}
      style={{ width: "100%", margin: "5px" }}
      options={options}
      onChange={(e) => setSurveyList(e)}
    />
  );
};

export default SurveyDropDown;
